import { toast } from "@/hooks/useToast";

export const showSuccessToast = (title: string, message?: string) => {
  return toast({ title: title, description: message, variant: "success" });
};

export const showErrorToast = (title: string, message?: string) => {
  return toast({ title: title, description: message, variant: "destructive" });
};
